import { AfterViewInit, DestroyRef, Directive, ElementRef, Input, OnInit } from '@angular/core';
import { ResizeObserverFactory } from '../service/resize-observer.factory';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs/operators';

@Directive({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[fixedFooter]',
})
export class FixedFooterDirective implements OnInit, AfterViewInit {
  @Input() virtual: boolean = false;

  private footerEl?: HTMLElement;
  private tableEl?: HTMLElement;
  private scrollContentEl?: HTMLElement;

  constructor(
    private elRef: ElementRef,
    private resizeObserverService: ResizeObserverFactory,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    const el = this.elRef.nativeElement;
    const children = el.previousSibling.children;
    if (this.virtual) {
      this.scrollContentEl = children[children.length - 1];
      if (this.scrollContentEl) {
        this.tableEl = this.scrollContentEl.children[0] as HTMLElement;
      }
    } else {
      this.tableEl = children[0];
      this.scrollContentEl = this.tableEl;
    }
    el.style.opacity = '0';
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.footerEl = this.elRef.nativeElement;
      if (this.footerEl && this.tableEl && this.scrollContentEl) {
        this.footerEl.style.width = `${this.tableEl.clientWidth}px`;
        this.footerEl.style.zIndex = '10';
        this.footerEl.style.position = 'relative';
        this.footerEl.style.opacity = '1';
        this.updateTableOffset();
        this.resizeObserverService.create(this.tableEl).pipe(
          takeUntilDestroyed(this.destroyRef),
          debounceTime(100)
        ).subscribe((size) => this.updateFooterWidth(size));
        this.resizeObserverService.create(this.footerEl).pipe(
          takeUntilDestroyed(this.destroyRef),
          debounceTime(100)
        ).subscribe((_size) => this.updateTableOffset());
      }
    }, 0);
  }

  private updateFooterWidth(size: { width: number, height: number }): void {
    if (this.footerEl) {
      this.footerEl.style.width = `${size.width}px`
    }
  }

  private updateTableOffset(): void {
    if (this.tableEl && this.footerEl) {
      this.tableEl.style.marginBottom = `${this.footerEl.clientHeight}px`;
      this.footerEl.style.marginTop = `-${this.footerEl.clientHeight}px`;
    }
  }
}
